/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaInvoice } from '../../models/criteria-invoice';
import { ReceiptWorklist } from '../../models/receipt-worklist';

export interface ApiBillingWorklistGetReceiptWorklistPost$Params {
      body?: CriteriaInvoice
}

export function apiBillingWorklistGetReceiptWorklistPost(http: HttpClient, rootUrl: string, params?: ApiBillingWorklistGetReceiptWorklistPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReceiptWorklist>>> {
  const rb = new RequestBuilder(rootUrl, apiBillingWorklistGetReceiptWorklistPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReceiptWorklist>>;
    })
  );
}

apiBillingWorklistGetReceiptWorklistPost.PATH = '/api/BillingWorklist/GetReceiptWorklist';
